import { useMemo } from "react";
import { withTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import "./Footer_1.scss";
import { checkForArabic } from "../../helpers/arabicLangValidator";
import logo from "../../assets/FP_Logo_Black.svg";
import emailLogo from "../../assets/icons/email.svg";
import phoneLogo from "../../assets/icons/phone.svg";
import instagramLogo from "../../assets/icons/instagram.svg";
import settings from "../../settings";
import TrustPilot2 from "../review/TrustPilot2";

const Footer = ({ t, selectedTag }) => {
  const isEnglishFooter = useMemo(() => {
    if (selectedTag) {
      return selectedTag.tag === "DXB" || selectedTag.tag === "AUH";
    }

    return window.IS_UAE;
  }, [selectedTag]);

  const trackMail = () => {
    if (window.IS_UAE && window.gtag) {
      window.gtag("event", "contact_mail_click", {});
    }
    if (window.IS_UAE && window.fbq) {
      window.fbq("trackCustom", "contact_mail_click");
    }
  };

  const trackPhone = () => {
    if (window.IS_UAE && window.gtag) {
      window.gtag("event", "contact_phone_click", {});
    }
    if (window.IS_UAE && window.fbq) {
      window.fbq("trackCustom", "contact_phone_click");
    }
  };

  const FooterLink = ({ url, children }) => {
    const isExternal = url?.startsWith("http");
    const handleClick = () => {
      window.scrollTo({ top: 0, behavior: "smooth" });
    };
    return isExternal ? (
      <a
        href={url}
        target="_blank"
        rel="noopener noreferrer"
        onClick={handleClick}
      >
        {children}
      </a>
    ) : (
      <Link to={url} onClick={handleClick}>
        {children}
      </Link>
    );
  };

  return (
    <footer className="main-footer">
      <div className="footer">
        <div className={`footer-menu2 ${checkForArabic("arabic-right-decor")}`}>
          <div className="left-section">
            <div className="fp-logo-col">
              <a href="/">
                <img className="fp-logo" src={logo} alt="Frank Porter" />
              </a>
            </div>
            <div className="icon-container">
              <div className="rounded-icon">
                <img src={emailLogo} className="icon" alt="email" />
              </div>
              <a
                className="footer-link"
                onClick={trackMail}
                href={`mailto:${t(
                  "address2ndLine" + (isEnglishFooter ? "En" : "Ru")
                )}`}
              >
                {t("address2ndLine" + (isEnglishFooter ? "En" : "Ru"))}
              </a>
            </div>
            <div className="icon-container">
              <div className="rounded-icon">
                <img src={phoneLogo} className="icon" alt="phone" />
              </div>
              <a
                onClick={trackPhone}
                className="footer-link"
                href={`tel:${t(
                  "address1stLine" + (isEnglishFooter ? "En" : "Ru")
                )}`}
              >
                {t("address1stLine" + (isEnglishFooter ? "En" : "Ru"))}
              </a>
            </div>
            <div className="icon-container" style={{ marginLeft: "0.5rem" }}>
              <TrustPilot2 theme={"dark"}/>
              <a
                rel="noopener noreferrer"
                target="_blank"
                href={`https://www.instagram.com/${
                  window.IS_UAE ? "mrfrankporter/" : "mrfrankporter.ru/"
                }`}
              >
                <img alt="instagramLogo" src={instagramLogo} className="icon" />
              </a>
            </div>
          </div>
          <div className="right-section">
            {settings.FooterItems.map((item, index) => (
              <div className="flex-col" key={index}>
                <ul>
                  <li className="list-item">
                    <FooterLink url={item.titleURL}>
                      {t(item.titleTranslationKey)}
                    </FooterLink>
                  </li>
                  {item.listItems.map((n, j) => (
                    <li className="list-sub-item" key={j}>
                      <FooterLink url={n.url}>{t(n.translationKey)}</FooterLink>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
        <div className="bottom-footer-content">
          <p>
            Copyright © {new Date().getFullYear()} Frank Porter Vacation Homes
            Rental LLC
          </p>
          <Link to={`/privacy-policy`}>{t("common:privacyPolicy")}</Link>
        </div>
      </div>
    </footer>
  );
};

export default withTranslation("common")(Footer);
